export const getCartVisibility = (state) => ({ visible: state.cart.visible });
export const getDefaultCartVisibility = () => false;
export const getCart = (state) => (state.cart);
